module.exports = __webpack_public_path__ + "img/pic2.3fa5fb65.png";